/**
 * @class
 * @function MegaMenuSidebar
 */
if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();

      this.hydratedPanels = new Set();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll(
        '.mega-menu-sidebar--button'
      );

      this.buttons.forEach((button, index) => {
        button.addEventListener('mouseover', (event) => {
          this.onHover(event, button, index);
        });

        button.addEventListener('focus', (event) => {
          this.onHover(event, button, index);
        });
      });

      /*
       * mega-menu-sidebar 位于顶部导航的 li 内。
       * 当鼠标进入 Connessione、Sicurezza、Domotica 等一级菜单时，
       * 立即插入并显示第一组推荐内容。
       */
      this.parentMenuItem = this.closest('li');

      if (this.parentMenuItem) {
        this.parentMenuItem.addEventListener('mouseenter', () => {
          this.activatePanel(0);
        });

        this.parentMenuItem.addEventListener('focusin', () => {
          if (this.hydratedPanels.size === 0) {
            this.activatePanel(0);
          }
        });
      } else {
        this.addEventListener('mouseenter', () => {
          this.activatePanel(0);
        });

        this.addEventListener('focusin', () => {
          if (this.hydratedPanels.size === 0) {
            this.activatePanel(0);
          }
        });
      }
    }

    hydratePanel(index) {
      if (this.hydratedPanels.has(index)) {
        return;
      }

      const template = this.querySelector(
        `.mega-menu-sidebar--content-template[data-panel-index="${index}"]`
      );

      const contentContainer = this.querySelector(
        '.mega-menu-sidebar--content'
      );

      if (!template || !contentContainer) {
        return;
      }

      const fragment = template.content.cloneNode(true);
      const panel = fragment.querySelector(
        '.mega-menu-sidebar--content-inner'
      );

      contentContainer.appendChild(fragment);
      template.remove();

      this.hydratedPanels.add(index);

      if (panel && window.lazySizes && window.lazySizes.loader) {
        panel.querySelectorAll('img.lazyload').forEach((image) => {
          window.lazySizes.loader.unveil(image);
        });
      }
    }

    activatePanel(index) {
      this.hydratePanel(index);

      const contentPanels = this.querySelectorAll(
        '.mega-menu-sidebar--content-inner'
      );

      contentPanels.forEach((content) => {
        const panelIndex = Number(
          content.getAttribute('data-panel-index')
        );

        content.classList.toggle(
          'active',
          panelIndex === index
        );
      });

      this.buttons.forEach((button, buttonIndex) => {
        button.classList.toggle(
          'active',
          buttonIndex === index
        );
      });
    }

    onHover(event, button, index) {
      this.activatePanel(index);
    }
  }

  customElements.define(
    'mega-menu-sidebar',
    MegaMenuSidebar
  );
}